import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PlanningHistoryEntry } from '../../../../classes/planning-history-entry';
import { Status } from '../../../../classes/status.class';
import { User } from '../../../../classes/user.class';
import { AuthorisationService } from '../../../../services/auth/authorisation.service';
import { Features } from '../../../../services/auth/features';
import { Functionalities } from '../../../../services/auth/functionalities';
import { PlanningService } from '../../../../services/planning/planning.service';
import { StatusService } from '../../../../services/planning/status.service';
import { UserService } from '../../../../services/user/user.service';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-status-input',
    standalone: false,
    templateUrl: './status-input.component.html',
    styleUrl: './status-input.component.scss',
})
export class StatusInputComponent extends InputComponent {
    private planningService = inject(PlanningService);
    private statusService = inject(StatusService);
    private userService = inject(UserService);
    private latestStatusChange: PlanningHistoryEntry;

    statusList$: Observable<Status[]>;
    users: User[] = [];

    get statusChange() {
        const controlStatus = this.formData?.form.controls.planning.get('status_key');

        return this.fc === controlStatus && this.latestStatusChange?.old_value !== this.fc.value
            ? this.latestStatusChange
            : null;
    }

    ngOnInit() {
        this.statusList$ = this.statusService
            .getList(this.field?.statusType)
            .pipe(
                map(statuses =>
                    statuses.filter(
                        status =>
                            status.key !== 'dagrapportVerwerkt' ||
                            this.fc.value === 'dagrapportVerwerkt' ||
                            AuthorisationService.hasFunctionality(Functionalities.DeclarationManagement)
                    )
                )
            );
        this.subscriptions.add(this.userService.getList(true).subscribe(users => (this.users = users)));

        const planningId = this.formData?.orginal?.id;
        const controlStatus = this.formData?.form.controls.planning.get('status_key');

        if (
            planningId &&
            this.fc === controlStatus &&
            AuthorisationService.hasFeature(Features.PlanningDetailHistory)
        ) {
            this.subscriptions.add(
                this.planningService.getHistoryForField(planningId, 'status_key').subscribe(change => {
                    this.latestStatusChange = change;
                })
            );
        }
    }
}
